(function () {
  'use strict';

  // ---------- Announcement rotation ----------
  function initAnnouncement() {
    var track = document.querySelector('[data-announcement]');
    if (!track) return;
    var items = track.querySelectorAll('.announcement-item');
    if (items.length < 2) return;
    var idx = 0;
    setInterval(function () {
      var cur = items[idx];
      idx = (idx + 1) % items.length;
      var next = items[idx];
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      next.classList.add('is-active');
      window.setTimeout(function () { cur.classList.remove('is-leaving'); }, 550);
    }, 4200);
  }

  // ---------- Mobile menu ----------
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.hidden;
      nav.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  // ---------- Collection sort ----------
  function initSortBy() {
    var select = document.querySelector('[data-sort-by]');
    if (!select) return;
    select.addEventListener('change', function () {
      if (select.value === 'best-selling') {
        window.location.href = '/collections/best-sellers';
        return;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  }

  // ---------- Product variant selection ----------
  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function initProduct() {
    var section = document.querySelector('[data-main-product]');
    if (!section) return;
    var form = section.querySelector('[data-product-form]');
    var jsonEl = section.querySelector('[data-variants-json]');
    if (!form || !jsonEl) return;

    var variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var button = form.querySelector('[data-add-to-cart]');
    var buttonText = form.querySelector('[data-add-to-cart-text]');
    var selectedLabel = section.querySelector('[data-selected-option]');

    var radios = form.querySelectorAll('input[name="option1"]');
    if (!radios.length) return;

    function findVariant() {
      var checked = form.querySelector('input[name="option1"]:checked');
      if (!checked) return null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option1 === checked.value) return variants[i];
      }
      return null;
    }

    function update() {
      var v = findVariant();
      if (!v) return;
      idInput.value = v.id;
      if (selectedLabel) selectedLabel.textContent = v.option1;
      if (priceEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceEl.innerHTML = formatMoney(v.price) + ' <s class="price-compare">' + formatMoney(v.compare_at_price) + '</s>';
        } else {
          priceEl.textContent = formatMoney(v.price);
        }
      }
      if (button) {
        button.disabled = !v.available;
      }
      if (buttonText) {
        buttonText.textContent = v.available ? 'Add to bag' : 'Sold out';
      }
    }

    radios.forEach(function (r) { r.addEventListener('change', update); });
    update();
  }

  // ---------- Cart count + AJAX add to cart ----------
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = el.classList.contains('mobile-bag-count') ? '(' + cart.item_count + ')' : cart.item_count;
          el.hidden = false;
        });
        document.querySelectorAll('.mobile-bag-link').forEach(function (link) {
          link.setAttribute('aria-label', 'Bag, ' + cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items'));
        });
      })
      .catch(function () {});
  }

  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      var idInput = form.querySelector('[data-variant-id]');
      if (!idInput) return;
      var buttonText = form.querySelector('[data-add-to-cart-text]');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: idInput.value, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return res.json();
        })
        .then(function () {
          updateCartCount();
          if (buttonText) {
            var original = buttonText.textContent;
            buttonText.textContent = 'Added ✓';
            setTimeout(function () { buttonText.textContent = original; }, 2000);
          }
        })
        .catch(function () {
          // fallback: standard form submission
          form.submit();
        });
    });
  }

  // ---------- Complete-the-look top + jeans offer ----------
  function initOutfitBundle() {
    var bundle = document.querySelector('[data-outfit-bundle]');
    var section = document.querySelector('[data-main-product]');
    if (!bundle || !section) return;
    var button = bundle.querySelector('[data-outfit-add]');
    var jeansSelect = bundle.querySelector('[data-outfit-jeans-variant]');
    var topVariant = section.querySelector('[data-product-form] [data-variant-id]');
    var status = bundle.querySelector('[data-outfit-status]');
    if (!button || !jeansSelect || !topVariant) return;

    button.addEventListener('click', function () {
      var topId = Number(topVariant.value);
      var jeansId = Number(jeansSelect.value);
      if (!topId || !jeansId) {
        if (status) status.textContent = 'Please choose a size for both pieces.';
        return;
      }
      button.disabled = true;
      button.textContent = 'Adding the outfit…';
      if (status) status.textContent = '';
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [
          { id: topId, quantity: 1 },
          { id: jeansId, quantity: 1 }
        ] })
      }).then(function (response) {
        if (!response.ok) throw new Error('cart-add-failed');
        return response.json();
      }).then(function () {
        if (status) status.textContent = 'Outfit added. Your jeans discount is applied in the bag.';
        window.location.href = '/cart';
      }).catch(function () {
        button.disabled = false;
        button.textContent = 'Add both — 5% off jeans';
        if (status) status.textContent = 'We could not add the outfit. Please try again.';
      });
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // ---------- Newsletter popup ----------
  function initNewsletterPopup() {
    var popup = document.querySelector('[data-newsletter-popup]');
    if (!popup) return;
    var summerSalePath = /^\/(summer-sale|collections\/summer-26)(?:\/|$)/.test(window.location.pathname);
    var summerProductHandles = ["frill-trim-halter-crop-top", "butter-yellow-satin-midi-dress", "tank-sundress-with-pockets", "seamless-ribbed-crop-top", "sage-green-one-shoulder-midi-dress", "polka-dot-halter-babydoll-mini-dress"];
    var summerProductPath = summerProductHandles.some(function (handle) {
      return window.location.pathname === '/products/' + handle;
    });
    if (!sessionStorage.getItem('mintrove_popup_shown') && !summerSalePath && !summerProductPath) {
      window.setTimeout(function () {
        if (popup.hidden) popup.hidden = false;
        sessionStorage.setItem('mintrove_popup_shown', '1');
      }, window.matchMedia('(max-width: 600px)').matches ? 120000 : 90000);
    }
    popup.querySelectorAll('[data-newsletter-close]').forEach(function (el) {
      el.addEventListener('click', function () { popup.hidden = true; });
    });
    var copy = popup.querySelector('[data-copy-code]');
    var code = popup.querySelector('[data-newsletter-code]');
    if (copy && code) {
      copy.addEventListener('click', function () {
        var text = code.textContent.trim();
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(function () {
            copy.textContent = 'Copied ✓';
            window.setTimeout(function () { copy.textContent = 'Copy'; }, 1500);
          });
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initMobileMenu();
    initSortBy();
    initProduct();
    initAddToCart();
    initOutfitBundle();
    initReveal();
    initNewsletterPopup();
    updateCartCount();
  });
})();
